import { useSyncExternalStore } from 'react';

import {
  hasAnalyticsConsent,
  subscribeToConsentChanges,
} from './useAnalyticsConsent.utils';

/**
 * Reactive analytics consent state.
 *
 * Returns the current value rather than firing transition callbacks, so it can
 * be used as a render input and effect dependency — required wherever a consent
 * withdrawal must invalidate memoized data.
 *
 * @returns `true` when consented, `false` when denied, or `null` before OneTrust loads
 *
 * @example
 * const hasConsent = useAnalyticsConsent();
 */
export function useAnalyticsConsent(): boolean | null {
  return useSyncExternalStore(subscribeToConsentChanges, hasAnalyticsConsent);
}
